import { CAMPAIGN_ACTION_TYPE } from "./campaign.action";

export const CAMPAIGN_MESSAGE_CONTEXT = {
	joinCampaign: CAMPAIGN_ACTION_TYPE.joinByCode,
	joinCampaignError: CAMPAIGN_ACTION_TYPE.joinByCodeFail,
	joinCampaignSuccess: CAMPAIGN_ACTION_TYPE.joinByCodeSuccess,

	optInCampaign: CAMPAIGN_ACTION_TYPE.optIn,
	optInCampaignError: CAMPAIGN_ACTION_TYPE.optInFail,
	optInCampaignSuccess: CAMPAIGN_ACTION_TYPE.optInSuccess,
};

export const CAMPAIGN_MESSAGE_CODES = {
	reward: {
		error: "E_CAMPAIGNS",
	},
	joinCampaign: {
		unhandled: "E_UNHANDLED",
		error: "E_CAMPAIGNS_OFFERS_ENROLLMENT",
		notFound: "E_CAMPAIGNS_ENROLLMENTS_CAMPAIGNNOTFOUND",
		alreadyEnrolled: "E_CAMPAIGNS_ENROLLMENTS_ALREADYENROLLED",
		success: "M_JOIN_CAMPAIGN_SUCCESS",
		unauthorized: "E_UNAUTHORIZED",
	},
	optInCampaign: {
		success: "M_JOIN_CAMPAIGN_SUCCESS",
		error: "E_CAMPAIGNS_OFFERS_ENROLLMENT",
		unhandled: "E_UNHANDLED",
		notFound: "E_CAMPAIGNS_ENROLLMENTS_CAMPAIGNNOTFOUND",
		alreadyEnrolled: "E_CAMPAIGNS_ENROLLMENTS_ALREADYENROLLED",
		unauthorized: "E_UNAUTHORIZED",
	},
};
